import styled from 'styled-components';

export const PaperPanelContainer = styled.div`
  background: ${props => props.theme.colors.white};
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
`;
